import { decorate, observable, runInAction, action } from "mobx";
import { getConversation, sendSMS } from "service/messageService";
import _ from "lodash";
import * as mobx from "mobx";
import { getAllGatewayMMS } from "service/gatewayMmsService";
import { getAllGatewaySMS, getAllRetailChat, getConversionMessages, patchConversationReadStatus } from "service/gatewayService";
import { MAX_MMS_IMAGES } from "constant/constant";
import { getFormatedContact } from "constant/messageConstants";

class ObservableMessageStore {
  conversation = [];
  pageSize = 10;
  current = 1;
  total = 0;
  sortField = "createdAt";
  sortOrder = "descend";
  search = "";
  selectedRoom = {};
  selectedMessage = undefined;
  conversationLoading = false;
  threadNextCursor = null;
  threadHasMore = false;
  latestConversationRequestId = 0;

  //iphone frame ui params
  phoneFrameCurrentMessage = undefined;
  phoneFrameSender = "GUNI SMS";
  phoneFrameSubject = undefined;
  phoneFrameImageUrl = null; // media files
  phoneFrameImageFileUrl = null; // url links
  mediaType = null;
  mediaName = null;
  phoneFrameImages = []; // multi-image: array of { file, type, name }
  currentSender = undefined;
  currentReciever = undefined;
  contactHistory = [];

  setCurrentMessage = message => {
    runInAction(() => {
      this.phoneFrameCurrentMessage = message;
    });
  };

  setPhoneSubject = subject => {
    runInAction(() => {
      this.phoneFrameSubject = subject;
    });
  };

  setPhoneSender = sender => {
    runInAction(() => {
      this.phoneFrameSender = sender;
    });
  };

  setCurrentImage = (image, url = false) => {
    runInAction(() => {
      if (url && image) {
        this.phoneFrameImageFileUrl = image;
        this.phoneFrameImageUrl = null;
      } else if (image) {
        this.phoneFrameImageFileUrl = null;
        this.phoneFrameImageUrl = image;
      } else {
        this.phoneFrameImageFileUrl = null;
        this.phoneFrameImageUrl = null;
      }
    });
  };

  addPhoneFrameImage = (file, type, name) => {
    runInAction(() => {
      if (this.phoneFrameImages.length >= MAX_MMS_IMAGES) return;
      this.phoneFrameImages = [...this.phoneFrameImages, { file, type, name }];
    });
  };

  removePhoneFrameImage = index => {
    runInAction(() => {
      this.phoneFrameImages = this.phoneFrameImages.filter((_, i) => i !== index);
    });
  };

  clearPhoneFrameImages = () => {
    runInAction(() => {
      this.phoneFrameImages = [];
    });
  };

  setData = (data, value) => {
    runInAction(() => {
      this[data] = value;
    });
  };

  setSelectedMessage = message => {
    runInAction(() => {
      const threadReceiver = message.contactNumber || message.receiver;

      if (this.conversationLoading && this.currentReciever === threadReceiver && this.currentSender === message.sender) {
        return;
      }

      this.latestConversationRequestId += 1;
      const requestId = this.latestConversationRequestId;

      let nameToUse = message.name || message.contact?.[0]?.name;
      if (!nameToUse && this.selectedMessage && this.selectedMessage.receiver === threadReceiver) {
        nameToUse = this.selectedMessage.name;
      }

      const isSameThread = this.currentReciever === threadReceiver && this.currentSender === message.sender;

      this.selectedMessage = {
        ...message,
        receiver: threadReceiver,
        name: nameToUse
      };
      this.phoneFrameSender = message.sender;
      // Keep current bubbles visible while the same thread refreshes.
      // Only clear when switching to a different conversation.
      if (!isSameThread) {
        this.conversation = [];
        this.total = 0;
        this.threadNextCursor = null;
        this.threadHasMore = false;
      }
      this.pageSize = 20;
      this.current = 1;
      this.conversationLoading = true;
      this.currentSender = message.sender;
      this.currentReciever = threadReceiver;

      this.getConversationHistory({
        receiver: threadReceiver,
        sender: message.sender,
        retailChat: !!message?.retailChat,
        requestId
      });
    });
  };
  loadMore = async () => {
    const retailChat = !!this.selectedMessage?.retailChat;
    if (retailChat) {
      if (this.current < this.totalPages) {
        this.current = this.current + 1;
        return this.getConversationHistory({
          receiver: this.currentReciever,
          sender: this.currentSender,
          retailChat: true,
          append: true
        });
      }
      return;
    }
    if (!this.threadHasMore || !this.threadNextCursor) return;
    return this.getConversationHistory({
      receiver: this.currentReciever,
      sender: this.currentSender,
      append: true
    });
  };

  canLoadMoreConversation = () => {
    if (this.selectedMessage?.retailChat) {
      return this.current < this.totalPages;
    }
    return this.threadHasMore;
  };
  setHistory = async message => {
    runInAction(async () => {
      this.pageSize = 50;
      return this.getContactHistory({
        receiver: message.receiver
      });
    });
  };

  custom_sort(a, b) {
    return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
  }
  getConversationHistory = async args => {
    const retailChat = !!args?.retailChat;
    const append = !!args?.append;
    let requestId = args?.requestId;
    // Soft refresh (no append): bump request id so a stale in-flight response
    // cannot wipe/replace the thread after a newer refresh has started.
    if (!append && requestId == null) {
      this.latestConversationRequestId += 1;
      requestId = this.latestConversationRequestId;
    }
    const method = retailChat ? getAllRetailChat : getConversionMessages;

    const params = {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      ...(args && args)
    };
    delete params.append;
    delete params.retailChat;
    delete params.requestId;

    if (retailChat) {
      params.page = append ? this.current : 1;
    } else {
      delete params.page;
      if (append && this.threadNextCursor) {
        params.message_id = this.threadNextCursor;
      }
    }

    if (this.search) {
      for (var key of Object.keys(this.search)) {
        if (this.search[key]) {
          params[key] = this.search[key];
        }
      }
    }
    params.limit = this.pageSize;

    const data = await method(params);
    try {
      runInAction(() => {
        if (requestId != null && requestId !== this.latestConversationRequestId) {
          return;
        }

        const { items = [], name, hidden } = data;

        let temp = [...items].reverse();

        if (append) {
          temp = temp.concat(mobx.toJS(this.conversation));
        }

        this.conversation = temp;
        this.pageSize = params.limit || this.pageSize;
        this.conversationLoading = false;

        if (retailChat) {
          const { total, current, totalPages } = data;
          this.current = current ?? (append ? this.current + 1 : 1);
          this.total = total;
          this.totalPages = totalPages;
        } else {
          const { hasMore, nextCursor } = data;
          this.threadHasMore = !!hasMore;
          this.threadNextCursor = nextCursor || null;
          this.current = 1;
          this.total = this.conversation.length;
          this.totalPages = hasMore ? 2 : 1;
        }

        if (this.selectedMessage) {
          const receiver = this.selectedMessage.contactNumber || this.selectedMessage.receiver;
          const apiNameIsPhoneOnly = name && receiver && (String(name).trim() === String(receiver).trim() || (/^\d+$/.test(String(name).replace(/\D/g, "")) && !/[a-zA-Z]/.test(String(name))));
          const keepInboxName = apiNameIsPhoneOnly && this.selectedMessage.name && this.selectedMessage.name !== receiver;

          this.selectedMessage = {
            ...this.selectedMessage,
            ...(name && !keepInboxName ? { name } : {}),
            ...(hidden !== undefined ? { hidden } : {})
          };
        }
      });
    } catch (error) {
      runInAction(() => {
        if (requestId != null && requestId !== this.latestConversationRequestId) {
          return;
        }
        this.status = "error";
        this.conversationLoading = false;
      });
    }
    return this.conversation;
  };

  newMessageEvent = messageObj => {
    try {
      runInAction(() => {
        if (this.conversation.length > 0) {
          const data = this.conversation?.[0];
          const { receiver, sender } = data;
          if ([receiver, sender].includes(messageObj?.conversationObj?.sender)) this.conversation.push(messageObj?.conversationObj);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  getContactHistory = async (args, isMms = false, isAdd = false) => {
    // call & save User list response
    const params = {
      page: this.current,
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      ...(args && args)
    };

    if (this.search) {
      for (var key of Object.keys(this.search)) {
        if (this.search[key]) {
          params[key] = this.search[key];
        }
      }
    }
    params.limit = 50;

    const data = isMms ? await getAllGatewayMMS(params) : await getAllGatewaySMS(params);
    try {
      runInAction(() => {
        const { items, total, current, limit: pageSize, totalPages } = data;
        let temp = [...items];
        if (isAdd) temp = temp.concat(mobx.toJS(this.contactHistory));
        this.contactHistory = temp;
        this.pageSize = pageSize;
        this.current = current;
        this.total = total;
        this.totalPages = totalPages;
      });
    } catch (error) {
      runInAction(() => {
        this.status = "error";
      });
    }

    return this.contactHistory;
  };

  setSearch = search => {
    runInAction(() => {
      this.search = search;
    });
  };

  getTotal = () => {
    return this.total;
  };

  setSelectedRoom = selectedRoom => {
    runInAction(() => {
      this.selectedRoom = selectedRoom;
      this.pageSize = 10;
      this.current = 1;
      this.total = 0;
    });
  };

  setPage = current => {
    runInAction(() => {
      this.current = current || 1;
    });
  };

  /**
   * get all test cases
   * @returns {Promise<[]>}
   */
  // getConversationHistory = async (room, isAdd) => {
  //   // call & save test case list response
  //   const params = {
  //     room,
  //     page: isAdd ? this.current + 1 : this.current,
  //     // sortField: this.sortField,
  //     // sortOrder: this.sortOrder
  //   };
  //   if (this.search.length > 0) params.search = this.search.search;
  //   const messageHistoryResponse = await getConversation(params);
  //   try {
  //     runInAction(() => {
  //       const {
  //         items,
  //         total,
  //         current,
  //         limit: pageSize,
  //       } = messageHistoryResponse;
  //       this.conversation = isAdd
  //         ? _.uniq(
  //             _.concat(
  //               mobx.toJS(this.conversation),
  //               items || messageHistoryResponse
  //             ),
  //             "_id"
  //           )
  //         : _.uniq(items || messageHistoryResponse, "_id");
  //       this.selectedTestCase = undefined;
  //       this.pageSize = pageSize;
  //       this.current = current;
  //       this.total = total;
  //     });
  //   } catch (error) {
  //     runInAction(() => {
  //       this.status = "error";
  //     });
  //   }

  //   return this.conversation;
  // };

  /**
   * Start Test Case
   * @param data
   * @returns {Promise<any>}
   */
  sendSMS = async (data, mode) => {
    return await sendSMS(data, mode);
  };

  addMessage = message => {
    try {
      runInAction(() => {
        if (this.selectedRoom && this.selectedRoom._id && message && message.room) {
          if (this.selectedRoom._id === message.room) {
            const oldLength = this.conversation.length;
            const newMessages = _.mergeById(this.conversation, message, "_id", true);
            const newLength = newMessages.length;
            if (oldLength < newLength) {
              this.conversation = newMessages;
              this.total = newMessages.length;
            }
          }
        }
      });
    } catch (error) {
      console.error("Error", error);
    }
    return this.conversation;
  };

  /** Show the typed outgoing bubble immediately while send is in flight. */
  appendOutgoingPreview = ({ message = "", sender, receiver, scheduleAt, isMMS = false, media = [] } = {}) => {
    const preview = {
      _id: `temp_preview_${Date.now()}`,
      message,
      mediatxt: message,
      sender,
      receiver,
      status: scheduleAt ? "scheduled" : "sent",
      createdAt: new Date().toISOString(),
      isMMS: !!isMMS,
      media: Array.isArray(media) ? media : [],
      isPreview: true
    };
    runInAction(() => {
      this.conversation = [...this.conversation, preview];
      this.total = this.conversation.length;
    });
    return preview;
  };

  removeOutgoingPreview = previewId => {
    if (!previewId) return;
    runInAction(() => {
      this.conversation = this.conversation.filter(msg => msg?._id !== previewId);
      this.total = this.conversation.length;
    });
  };

  /**
   * Mark conversation as unread (REST: PATCH read status to false).
   * Caller should update list UI (e.g. gatewayStore.setConversationUnread) and optionally refresh.
   * @param {string} receiver
   * @param {string} sender
   * @param {boolean} [retailChat=false]
   * @returns {Promise<any>}
   */
  markConversationUnread = async (receiver, sender, retailChat = false) => {
    return patchConversationReadStatus({
      receiver,
      sender,
      read: false,
      retailChat
    });
  };

  /**
   * Mark conversation as read (REST: PATCH read status to true).
   * @param {string} receiver
   * @param {string} sender
   * @param {boolean} [retailChat=false]
   * @returns {Promise<any>}
   */
  markConversationRead = async (receiver, sender, retailChat = false) => {
    return patchConversationReadStatus({
      receiver,
      sender,
      read: true,
      retailChat
    });
  };

  // Refresh selected message name from conversation API
  // This is used to update the contact name in the chat header after adding contact to group
  refreshSelectedMessageName = async (receiver, sender, retailChat = false) => {
    try {
      // Call the conversation API to get latest data with updated name
      const method = retailChat ? getAllRetailChat : getConversionMessages;
      const params = {
        sortField: "createdAt",
        sortOrder: "descend",
        receiver,
        sender,
        retailChat,
        limit: 20,
        _t: Date.now()
      };

      const data = await method(params);

      // The API returns data with items array and a name field
      // Check for name in the response data directly or from items
      let updatedName = null;

      if (data && data.name) {
        // If the API returns name directly at the top level
        updatedName = data.name;
      } else if (data && data.items && data.items.length > 0) {
        // If the API returns items array, get name from the first item
        updatedName = data.items[0]?.name;
      }

      if (updatedName) {
        runInAction(() => {
          const normalizedReceiver = getFormatedContact(receiver);
          const normalizedSelected = getFormatedContact(this.selectedMessage?.receiver || "");
          if (this.selectedMessage && normalizedReceiver && normalizedReceiver === normalizedSelected) {
            this.selectedMessage = {
              ...this.selectedMessage,
              name: updatedName
            };
          }
        });
        return updatedName;
      }
    } catch (error) {
      console.error("Error refreshing message name:", error);
    }
    return null;
  };
}

decorate(ObservableMessageStore, {
  selectedRoom: observable,
  conversation: observable,
  pageSize: observable,
  current: observable,
  total: observable,
  sortField: observable,
  sortOrder: observable,
  search: observable,
  selectedMessage: observable,
  conversationLoading: observable,
  threadNextCursor: observable,
  threadHasMore: observable,
  phoneFrameCurrentMessage: observable,
  phoneFrameSubject: observable,
  phoneFrameSender: observable,
  phoneFrameImageUrl: observable,
  phoneFrameImageFileUrl: observable,
  mediaType: observable,
  mediaName: observable,
  phoneFrameImages: observable,
  contactHistory: observable
});
export default new ObservableMessageStore();
